import { schema_user_chat_option } from 'adv-lib/src/models/chat/user-chat-option'
import { schema_user_chat_property } from 'adv-lib/src/models/chat/user-chat-property'
import { unified_club_market_cache } from 'adv-lib/src/models-mongod/pro/unified_club_cache'
import {
  FEED_SUPPLIER, GAME_BANNER_DETAIL_BUTTON_TYPE, GAME_BANNER_STATE, GAME_BANNER_TYPE,
  MARKET_PROVIDER,
  MISSION_STATE,
  NOTICE_POSITION,
  NOTICE_STATE,
} from 'adv-lib/src/v2/constants/common'
import * as bigint from 'big-integer'
import { GAME_TYPE } from 'adv-lib/src/game-type/game-market-types'

import { schema_club_notice } from '../../models/shard-club/club_notice'
import { MissionType } from '../../game-type/mission-type'
import {
  AUTHENTICATION_TYPE,
  BET_MONEY_TYPE,
  CLUB_NOTICE_TYPE,
  KICK_REASON,
  MISSION_PERIOD_TYPE,
  PLAY_BLOCK_TYPE,
  PROPERTY_ID,
} from 'adv-protocol/src/GameCommon'

export interface Schema$ResponseBase {
  /**
   * axios client query error!
   */
  statusCode?: number
  error?: string

  // common server result without exception
  errcode?: number
  user?: Schema$UserInfo
  errMsg?: string
}

export interface Schema$RateFailBetFold {
  typeOn: number
  matchId: number
  liveOddsId: string
  marketType: string
  specialBetValue: string
  selection: string
  clientRate: string
  serverRate: string
}

export interface Schema$UserExtraOddsItemMap {
  [key: string]: number
}

export interface Schema$UserInfo {
  id?: string
  cash?: number
  mileage?: number
  point?: number
  money?: number
  heart?: number
  dia?: number
  diaCasino?: number
  ticket?: number
  job?: number
  nick?: string
  avatar?: string
  customProfileImg?: boolean
  present_box_openedAt?: Date
  clubId?: string
  isSpecificClubMember?: boolean
  chatOption?: Partial<schema_user_chat_option>
  chatProperty?: Partial<schema_user_chat_property>
  isPlayBlock?: boolean
  playBlockType?: PLAY_BLOCK_TYPE
  playBlockTime?: Date
  userExtraOddsItems?: Schema$UserExtraOddsItemMap
  userPickCount?: number
  moneySingleBetEnabled?: boolean
  diaSingleBetEnabled?: boolean
  betTicketSingleBetEnabled?: boolean
  userTitleId?: number
  userTitleEnabled?: boolean
  isSpecialMember?: boolean
  sMemberMark?: boolean
}

export interface Schema$MemberInfo {
  account: string
  name?: string
  gender?: number
  phone?: string
  email?: string
  last_connected_date?: Date
  pw_change_date?: Date
  phone_send?: string
  age?: string
}

export interface Schema$Certification {
  ci: string
  name: string
  lastAuthDate: Date
  createdAt: Date
}

export interface Schema$Auth {
  id: string
  authKey: string
}

export interface Schema$Recommend {
  rcode: string
}

export interface Schema$Account {
  id: string
  userNum: string
  sign: string,
}

export interface Schema$SimpleClubInfo {
  id?: string
  name?: string
  grade?: number
  isMember?: boolean
  isRecommendClub?: boolean
  recommendClubOrder?: number
  notice?: Schema$SimpleClubNotice
  copyImageUrl?: string
  emblemImageUrl?: string
  listImageUrl?: string
  listTextImageUrl?: string
  backgroundImageUrl?: string
  memberCount?: number
}

export interface Schema$SimpleClubNotice {
  id: string
  clubId: string
  type: CLUB_NOTICE_TYPE
  title?: string
  contents?: string
}

// 베팅슬립, 베팅내역 클럽정보표시 기능 추가 테스트를 위해 작성한 더미 코드입니다.
// [이슈링크](https://task.zempublic.co.kr/view.php?id=9961)
// labelImageUrl : 베팅슬립에 출력되는 이미지
// listImageUrl : 베팅내역에 출력되는 이미지
// bgImageUrl : 매치업 내 이벤트 버튼 뒤 출력되는 클럽 이미지
export const clubDummy = {
  labelImageUrl: 'https://d1i7hydgfclv7m.cloudfront.net/data_center/chat/images/small/7eca1bd7-5518-431d-a7eb-bb13fafe6260.webp',
  listImageUrl: 'https://d1i7hydgfclv7m.cloudfront.net/data_center/chat/images/ad52cea1-cdd1-4f97-8ba7-5fb504cefb1a.webp',
  bgImageUrl: 'https://d1i7hydgfclv7m.cloudfront.net/data_center/chat/images/small/68ae80e8-272d-4c13-bea6-11fbd0a608b4.webp',
}

export interface Schema$ClubInfo {
  id?: string
  ownerId?: string
  name?: string
  soluble?: number
  state?: number

  pre_betmoney_min?: number
  pre_betmoney_max?: number
  live_betmoney_min?: number
  live_betmoney_max?: number
  special_betmoney_min?: number
  special_betmoney_max?: number
  hit_max?: number
  limit_betting_rate?: number

  isMember?: boolean
  memberState?: number

  eventNotices?: schema_club_notice[]

  isExpelled?: boolean

  clubJoinState?: number // === GameCommon.SEEK_APPROVE_TYPE

  isRecommendClub?: boolean
  copyImageUrl?: string
  emblemImageUrl?: string
  listImageUrl?: string
  listTextImageUrl?: string
  backgroundImageUrl?: string
  memberCount?: number

  grade?: number
  recommendClubOrder?: number
}

export interface Schema$ClubOption {
  pre_betmoney_min?: number
  pre_betmoney_max?: number
  live_betmoney_min?: number
  live_betmoney_max?: number
  special_betmoney_min?: number
  special_betmoney_max?: number
  hit_max?: number
  limit_betting_rate?: number
}

export interface Schema$UserMission {
  id: string
  defId: number
  name: string
  conditionType: MissionType
  periodType: MISSION_PERIOD_TYPE
  currentCount: number
  clearCount: number
  missionComplete: boolean
  rewardComplete: boolean
  propertyId: PROPERTY_ID
  state: MISSION_STATE
}

export interface Schema$SettlementSupport {
  showGuidePopup?: boolean
  guideBonusReceived?: boolean
  showFirstBetPopup?: boolean
  showAchieveGoalPopup?: boolean
  achieveGoalValue?: number
  totalBetMoney?: number
  showVocPopup?: boolean
}

export interface Schema$UserConditionState {
  isFirstBetByCivalue?: boolean
}

export interface Schema$UserGuideBonusResult {
  result: boolean
}

export interface Schema$GameBanner {
  id: string
  order: number
  type: GAME_BANNER_TYPE
  state: GAME_BANNER_STATE
  desc: string
  bannerImageUrl: string
  contentsImageUrl: string
  homeImageUrl: string
  buttonImageUrl: string
  matchupBottomImageUrl: string
  clubEventPostEnabled: boolean
  matchupBottomPostEnabled: boolean
  maintenanceEnabled: boolean
  buttons?: Schema$GameBannerDetailButton[]
}

export interface Schema$GameBannerDetailButton {
  id: number,
  buttonType: GAME_BANNER_DETAIL_BUTTON_TYPE
  buttonImage: string,
  createdAt: Date,
}

// 테스트를 위해 추가한 코드입니다. [이슈링크](https://task.zempublic.co.kr/view.php?id=10141)
export enum BANNER_BUTTON_TYPE {
  ANDROID = 'Android',
  IOS = 'iOS',
}

export interface Schema$GiftBoxGameBanner extends Schema$GameBanner {
  clubId?: string
}

export interface Schema$BettingRule {
  isNotice: number
  title: string
  content: string
}

export interface Schema$UserMessageTopic {
  userId: string
  unreadMessageCount: number
}

export interface Schema$UpdateLiveMatchCountTopic {
  clubId: string
  liveMatchCount: number
}

export interface Schema$UpdateBettingTotalCount {
  totalCount: number
}

export enum PAGE_TYPE {
  MATCHUP = 'matchup',
  MATCHUP_RESULT = 'matchupResult',
  MATCHUP_DETAIL = 'matchupDetail',
  SPORT = 'cross',
  LIVE = 'live',
  BETTING_HISTORY = 'betting-history',
  MATCHUP_FILTER = 'matchupFilter',
  MATCHUP_RESULT_FILTER = 'matchupResultFilter',
  USER_PICK = 'userPick',

  USER_PICK_HOME = 'userPickHome',
  USER_PICK_DETAIL = 'userPickDetail',
  USER_PICK_MATCH_FILTER = 'userPickMatchFilter',
  USER_PICK_PROFILE = 'userPickProfile',
  MATCHUP_DETAIL_PICK = 'matchupDetailPick',    // 상세 BET - 분석글 탭
}

export enum SPORTS_TYPE {
  // 인기경기 탭 테스트를 위한 더미코드입니다.[이슈링크](https://task.zempublic.co.kr/view.php?id=9859)
  HOT = '-2',
  TODAY = '-1',
  ETC = '0',
  SOCCER = '1',
  BASKETBALL = '2',
  BASEBALL = '3',
  VOLLEYBALL = '23',
  ICE_HOCKEY = '4',
  TABLE_TENNIS = '20',
  // TODO: 10577 - 마이벳 타입 추가, SportTab/index.tsx getMyMatchTabList 함수에 적용
  TENNIS = '5',
}

export enum SPORTS_TYPE_NUM {
  ETC = 0,
  SOCCER = 1,
  BASKETBALL = 2,
  BASEBALL = 3,
  VOLLEYBALL = 23,
  ICE_HOCKEY = 4,
  LEAGUE_OF_LEGENDS = 110,
  TABLE_TENNIS = 20,
  HANDBALL = 6,
  TENNIS = 5,
}

export enum LS_SPORTS_TYPE {
  TODAY = '-1',
  ETC = '0',
  SOCCER = '6046',
  BASKETBALL = '48242',
  BASEBALL = '154914',
  VOLLEYBALL = '154830',
  ICE_HOCKEY = '35232',
}

export enum LS_SPORTS_TYPE_NUM {
  SOCCER = 6046,
  BASKETBALL = 48242,
  BASEBALL = 154914,
  VOLLEYBALL = 154830,
  ICE_HOCKEY = 35232,
  HANDBALL = 35709,
}

export enum PICK_LIST_ORDER {
  ASCENDING = 0,
  DESCENDING = 1,
}

export enum PICK_LIST_FILTER {
  DATE_PUBLISH = 0,
  DATE_CLOSE = 1,
  SELL_COUNT = 2,
  PRICE = 3,
  DIVIDEND_RATE = 4,
  FOLD_COUNT = 5,
}

export enum PICK_ESTATE {
  NONE = 0,
  PUBLISHED = 1,
  PURCHASED = 2,
}

export enum ACCOUNT_TYPE {
  GOOGLE = 'google',
  LOCAL = 'local',
  AUTH_KEY = 'authkey',
  KAKAO = 'kakao',
  NAVER = 'naver',
  APPLE = 'apple',
}

export enum MESSAGE_ITEM_ORIGIN {
  ATTENDANCE_REWARD = 'attendance reward',
  DONATION = 'donation',
  SYSTEM = 'system',
  ADMIN = 'admin',
  MISSION_REWARD = 'mission reward',
  PRESENT = 'present',
  RESERVED_EVENT = 'reserved event',
  EVENT_REWARD = 'event reward',
  COUPON = 'coupon',
  PICK_MARKET = 'pick_market',
  IN_APP = 'inapp',
  SHOP = 'shop',
  FIRST_BET_MONEY_REWARD = 'first bet money reward',
  GUIDE_BONUS = 'guide bonus',
  PAYMENT_REWARD_EVENT = 'payment reward event',
  FRIEND_INVITATION_REWARD = 'friend invitation reward',
  DAILY_BETTING_EVENT_REWARD = 'daily betting event reward',
  DAILY_USER_PICK_REWARD = 'daily user pick reward',
  TODAY_USER_PICK_REWARD = 'today user pick reward',
  USER_PICK_S_MEMBER_REWARD = 'user pick special member reward',
  USER_PICK_WELCOME_REWARD = 'user pick welcome reward',
  USER_PICK_DASHBOARD = 'user pick dashboard', // 해당값으로 디비 조회를 하므로 수정 되어서는 안된다. 수정시 디비 값도 수정할것. messages.itemOrigin
  USER_ACTIVITY_REWARD = 'user activity reward',
  MAJOR_USER_GROUP_REWARD = 'major user group reward',
  EXTRA_PAYMENT_REWARD_EVENT = 'extra payment reward event',
  RANKING_EVENT_REWARD = 'ranking event reward',
  SIGNUP_QUIZ_REWARD = 'signup quiz reward',
  TELEGRAM_EVENT_REWARD = 'telegram event reward',
  TELEGRAM_LINK_REWARD = 'telegram link reward',
}

export enum ATTENADNCE_TYPE {
  NEWBIE = 1,
  COMMON = 2,
}
export enum ATTENDANCE_ROUND {
  DAYS_7 = 1,
  DAYS_15 = 2,
  DAYS_28 = 3,
}

export enum EVENT_REWARD_PARENT_NAME {
  ATTENDANCE = 'attendance_defs',
}

export enum BET_STATE {
  FAILURE = 0,
  SUCCESS = 1,
}

export enum BET_TICKET_TYPE {
  TICKET_TYPE1 = 10000,
  TICKET_TYPE2 = 100000,
  TICKET_TYPE3 = 500000
}

export enum PUBLISH_MONEY_TYPE {
  HEART,
  TICKET
}

// 상단 header가 호출되지 않아야하는 페이지
export enum PAGE_WITHOUT_HEADER {
  HOME = 'home',
  TODAY_PICK = 'today-pick-detail',
  USER_PICK = 'user-pick',
  ADV_NEWS = 'adv-news',
}

export const LIMIT_BET_TICKET_RATE = 1.0
export const HEART_FROM_TICKET_RATIO = 100000 // 픽공유시에 하트와 티켓의 비율 하트= 1  베팅권 = 10 1만 베팅권 10000  고로 하트 = 10 * 10000
export const FIRST_BET_MONEY = 60000 // 첫 베팅조건 체크시 베팅금액 기준

export enum LogoutType {
  USER = 'byUser', DUPLICATE = 'byDuplicate', KICK = 'byKick',
}

export enum PostMessageType {
  WELCOME = 'welcome',
  EVENT = 'event',
  WELCOME_RECOMMENDER = 'welcome_recommender',
  // S 멤버십 선정 안내 메시지
  S_MEMBER_WELCOME = 's_member_welcome',
}
//
// export enum BANNER_ETYPE {
//   EVENT = 0,
//   GIFTBOX = 1,
// }

export interface UserBetSinglePenaltyInfo {
  userId: string
  userNick: string
  penalty: number
  createdAt: string // YYYY-MM-DD HH:mm:ss
  updatedAt: string
}

export enum EXCEPTION_TYPE {
  AUTHENTICATION_FAILURE = 'AuthenticationFailureException',
  CERTIFICATION_NOT_FOUND = 'CertificationNotFoundException',
  CERTIFICATION_EXPIRED = 'CertificationExpiredException',
  DATABASE_DUPLICATED = 'DatabaseDuplicatedException',
  DATABASE_NOT_FOUND = 'DatabaseNotFoundException',
  ACCOUNT_DUPLICATED = 'AccountDuplicatedException',
  INVALID_BUSINESS_LOGIC = 'InvalidBusinessLogicException',
  INVALID_PARAMETER = 'InvalidParameterException',
  INVALID_PERMISSION = 'InvalidPermissionException',
  LOGOUT = 'LogOut',
  SERVER_STATUS = 'ServerStatusException',
  UNAUTHORIZED_EXCEPTION = 'UnAuthorizedException',
  USER_NICK_NAME_NOT_FOUND = 'UserNicknameNotFoundException',
}

export interface SimpleMatchInfo {
  matchId: number
  sportId: number
  categoryId: number
  tournamentId: number
  seasonId: number
  dateOfMatch: Date
  homeTeamName: string
  awayTeamName: string
  feedSupplier: FEED_SUPPLIER
  gameType: GAME_TYPE
}

/**
 * @property {object} regularMarkets 메인에 출력될 마켓 목록
 * @property {object} irregularMarkets 상세에 출력될 마켓 목록
 */
export interface SeparateMarketData {
  regularMarkets: { [marketType: string]: { [specifierKey: string]: unified_club_market_cache } }
  irregularMarkets: { [marketType: string]: { [specifierKey: string]: unified_club_market_cache } }
}

export interface FriendInvitationRewardReceivedStatus {
  id: string,
  standard: number,
  standardName: string,
  rewardName: string,
  reward: number,
  receivedUserNickName: string,
  receivedAt: Date,
  isReceived: boolean,
}

export interface FriendInvitationInvitor {
  startOfMonth: Date,
  betMoneyType: BET_MONEY_TYPE,
  invitedUserCount: number,
  invitedBettingUserCount: number,
  rewardReceivedStates: FriendInvitationRewardReceivedStatus[],
  invitedUsersBettingMoneySummary: { betMoneyType: BET_MONEY_TYPE, membershipClubBettingMoney: bigint.BigInteger }[],
}

export interface FriendInvitationInvitedUser {
  startOfMonth: Date,
  betMoneyType: BET_MONEY_TYPE,
  userPromiseId: string,
  nick: string,
  bettingMoneySummary: bigint.BigInteger
  invitedJoinAt: Date,
}

export interface ItemQuantityProperties {
  quantity: bigint.BigInteger,
  period: number,
  volume: bigint.BigInteger,
}

export interface Notice {
  id: number
  order?: number
  author: string
  isTopNotice: NOTICE_POSITION
  category: string
  title: string
  content: string
  externalUrl: string
  youtubeUrl: string
  description: string
  state: NOTICE_STATE
  firstEnabledStateAt: Date
  thumbnailUrl: string
  createdAt: Date
  isVisibleBadge?: boolean
  isVisibleMatchup?: boolean
}

export interface BalanceResultParam {
  userId: string
  hitState: number
  betProperty: number
  winMoney: bigint.BigInteger
  clubBetId: string
  betRate: number
  sportId: number
  feedSupplier: FEED_SUPPLIER
  marketProvider: MARKET_PROVIDER
}

export interface UrgencyMessage {
  title: string
  content: string
}

export interface FeedSupplierValue {
  feedSupplier: FEED_SUPPLIER
  marketProvider: MARKET_PROVIDER
}

export interface ForefrontPopup {
  id: string,
  displayStartAt: Date,
  imageUrl?: string,
  notice?: Notice
}

export interface SportsFeedMarketProvider {
  pre: MARKET_PROVIDER
  live: MARKET_PROVIDER
}

export interface AuthenticationCache {
  phone: string
  name: string
  gender: string
  birth: string
  authType: AUTHENTICATION_TYPE
  createdAt: number
}

export interface Pagination {
  limit: number
  offset: number
}

export interface MetaNameField {
  ko?: string
  en?: string
}

export type Specifiers = { [p: string]: string }

export interface CustomNameFieldForSport {
  [sportId: string]: MetaNameField
}

export interface KickMessage {
  // RedisPublishService.publishUserKickInV2 에서 사용.
  code?: KICK_REASON
  text?: string
  promiseId?: string // user promise id
  // 아래는 v1 에서 사용. (RedisService.doSignOutPreviousIdToV1)
  to?: string
  userId?: string // user promise id
  uid?: string // session unique id
  sid?: string // session id
  reason?: KICK_REASON
}

export interface LiveMatchCount {
  clubId: string // club promise id
  liveMatchCount: number
}

export interface UserBetTotalCount {
  userId: string // user promise id
  totalCount: number
}

export interface AdvReqParams {
  // express.Request 타입변환 에러 수정을 위함.
  // TS2352: Conversion of type 'ParsedQs' to type 'Params' may be a mistake because neither type sufficiently
  // overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  // Property 'id' is missing in type 'ParsedQs' but required in type 'Params'.
  //
  // express-serve-static-core 버전이 4.17.2 > 4.17.32 올라가면서 express.Request 인터페이스를 타입으로 사용하면
  // ParsedQs 를 원하는 파라메터로 as 키워드를 사용할 수 없게 됨에 따라 커스텀 인터페이스 적용을 위해
  // 빈 인터페이스를 정의 하여 사용한다.
  // 참조: https://stackoverflow.com/questions/63538665/how-to-type-request-query-in-express-using-typescript#answer-73089957
}

export interface AdvResBody {
  // express.Request 타입변환 에러 수정을 위함.
  // TS2352: Conversion of type 'ParsedQs' to type 'Params' may be a mistake because neither type sufficiently
  // overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  // Property 'id' is missing in type 'ParsedQs' but required in type 'Params'.
  //
  // express-serve-static-core 버전이 4.17.2 > 4.17.32 올라가면서 express.Request 인터페이스를 타입으로 사용하면
  // ParsedQs 를 원하는 파라메터로 as 키워드를 사용할 수 없게 됨에 따라 커스텀 인터페이스 적용을 위해
  // 빈 인터페이스를 정의 하여 사용한다.
}

export interface AdvEmptyReq {
  // express.Request 타입변환 에러 수정을 위함.
  // TS2352: Conversion of type 'ParsedQs' to type 'Params' may be a mistake because neither type sufficiently
  // overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
  // Property 'id' is missing in type 'ParsedQs' but required in type 'Params'.
  //
  // express-serve-static-core 버전이 4.17.2 > 4.17.32 올라가면서 express.Request 인터페이스를 타입으로 사용하면
  // ParsedQs 를 원하는 파라메터로 as 키워드를 사용할 수 없게 됨에 따라 커스텀 인터페이스 적용을 위해
  // 빈 인터페이스를 정의 하여 사용한다.
  // 참조: https://stackoverflow.com/questions/63538665/how-to-type-request-query-in-express-using-typescript#answer-73089957
}

export interface Schema$ExtraOddsItemDefDetail {
  name: string
  rate: number
  maxCount: number
  itemId: number
  propertyId: number
  imgBaseUrl?: string
  cardImgUrl?: string
  betSlipCardImgUrl?: string
  myPageImgUrl?: string
}

export interface UserExtraOddsItem {
  key: number
  propertyId: number
  rate: number
  imgBaseUrl?: string
  cardImgUrl?: string
  betSlipCardImgUrl?: string
  myPageImgUrl?: string
  name: string,
  styleClass?: string,
}

export interface BetLimitScoreInfo {
  sportId: number
  score: number
  markets: number[]
  isPeriodScore: boolean
  periodLimitScores?: {
    period: number
    score: number
  }[]
}

export interface ExtraOddsItemAvailableFoldCondition {
  minimumOutcomeRate: number
  minimumOutcomeRateFoldCount: number
}

export interface MatchupEtcFilterAlertOptions {
  enabled: boolean
  imageFileName?: string
  imageUrlPrefix?: string
  updatedAt?: number
}

export interface Schema$RegistrationSourceDef {
  id: string,
  name: string,
  order: number,
  enabled: boolean,
}

export interface DeactivatedCategory {
  sportId: number
  categoryId: number
}

export interface BasicPeriodParam {
  promiseId: string
  period: string[] // 0: from, 1: to
  betMoneyType?: BET_MONEY_TYPE
}

export interface Schema$CommunicationBlockUserInfo {
  userPromiseId: string
  userNick?: string
  userProfileImg?: string
}

export interface Schema$userTitleDef {
  id: number
  title: string
  titleMarkFileName: string
}

export interface AccountTransferOptions {
  enable?: number,
  period?: {
    from?: string,
    to?: string,
  },
  popupHideEnable?: number,
}

export type RiskTelegramAlarmMessageOption = {
  excludeNicks: string[]
  limitAlarmCount: number
}

export type RiskTelegramAlarmMessageOptionsType = {
  ip: RiskTelegramAlarmMessageOption
  nick: RiskTelegramAlarmMessageOption
  phone: RiskTelegramAlarmMessageOption
  message: RiskTelegramAlarmMessageOption
}

export type DeviceType = 'pc' | 'mobile'

export interface Schema$MajorUserMyPageInfo {
  groupTypeId: number
  myPageIconImageUrl: string
  myPageSkinImageUrl: string
  myPageDetailImageUrl: string
  myPageProfileBorderLineImageUrl: string
}

export interface Schema$GameHomeMainBanner {
  id: string
  state: GAME_BANNER_STATE
  desc: string
  order: number
  mobileImage: string
  mobileImageUrl: string
  pcImage: string
  pcImageUrl: string
}

export interface SportTalkMatchTimelineOptions {
  enabled: boolean
  enabledAt: string
  disabledAt: string
}

export interface SportTalkDashboardOptions {
  pickUserProfileEnabled: boolean
  matchInsightAutoUploadSettings: {
    enabled: boolean
    enabledAt: Date
    sportSettings: {
      [sportId: number]: string[]
    }
  }
}

export enum BANNER_POSITION_TYPE {
  TOP = 'top',
  BOTTOM = 'bottom',
  MIDDLE = 'middle',
  NONE = 'none',
}

export interface ChampPokerDeepLink {
  storeUrl: string,
  storeScheme: string,
  appScheme: string,
}

export enum DETAIL_TAB {
  PROCESSED,
  CLOSED
}
